// Color variants of the site, switched at runtime (see useThemeVariant). The first one is
// the default. Every variant must define the same colors. Besides Vuetify's own:
// - `secondary` is the ink drawn over the backdrop: text, icons.
// - `network` is the color of the background's nodes and links (faded with depth).
// - `glow` lights the background's code screen: caret, fresh characters, strings, numbers.
// - `surface` is the background of the solid sections (resume, code screen).
// - the backdrop is a gradient from `backdrop-start` (left) to `backdrop-end` (right).
// Effects that aren't colors (logo filters...) are styled under [data-theme='<name>'].

const status = {
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
};

export const themes = {
    twilight: {
        label: 'Twilight',
        icon: 'mdi-weather-sunny',
        colors: {
            primary: '#4C6FFF',
            secondary: '#DCE5FF',
            accent: '#38E1FF',
            network: '#4A5D9E',
            glow: '#38E1FF',
            surface: '#05070F',
            'backdrop-start': '#02030A',
            'backdrop-end': '#13225F',
            'active-tab': '#131930',
            ...status,
        },
    },
    daylight: {
        label: 'Daylight',
        icon: 'mdi-weather-night',
        colors: {
            primary: '#6258D8',
            secondary: '#292e34',
            accent: '#00BCD4',
            network: '#292e349d',
            glow: '#FFFFFF',
            surface: '#292e34',
            'backdrop-start': '#00BCD4',
            'backdrop-end': '#6258D8',
            'active-tab': '#333B52',
            ...status,
        },
    },
};
